var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tooltip)?_c('span',{staticClass:"tooltip",attrs:{"data-tooltip":_vm.tooltip}},[_vm._v(_vm._s(_vm.label)+":")]):_c('span',[_vm._v(_vm._s(_vm.label)+":")])}
var staticRenderFns = []

export { render, staticRenderFns }